const amountFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
const percentFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'percent',
  maximumFractionDigits: 1,
  signDisplay: 'exceptZero',
});

export function formatAmount(amount: number) {
  return amountFormatter.format(amount);
}

/** Signed variation, e.g. `+12,5 %`. `ratio` is 0.125 for +12.5 %. */
export function formatVariation(ratio: number) {
  return percentFormatter.format(ratio);
}

const shareFormatter = new Intl.NumberFormat('fr-FR', { style: 'percent', maximumFractionDigits: 1 });

/** Share of a whole, e.g. `25 %`. `ratio` is 0.25 for 25 %. */
export function formatShare(ratio: number) {
  return shareFormatter.format(ratio);
}
